import {
  ACTION_POST_REFUND_BOOKING,
  ACTION_POST_REFUND_BOOKING_SUCCESS,
  ACTION_POST_REFUND_BOOKING_FAILURE,
  ACTION_RESET_POST_REFUND_BOOKING,
} from '../configs/ActionTypes';

const initialState = {
  isLoading: false,
  success: null,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTION_POST_REFUND_BOOKING: {
      return {
        ...state,
        isLoading: true,
        success: null,
      };
    }

    case ACTION_POST_REFUND_BOOKING_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    }

    case ACTION_POST_REFUND_BOOKING_FAILURE: {
      return {
        ...state,
        success: false,
        isLoading: false,
      };
    }

    case ACTION_RESET_POST_REFUND_BOOKING: {
      return initialState;
    }

    default: {
      return state;
    }
  }
}
